import type { ComponentProps } from "react";

import { cn } from "../../lib/utils";
import { useDialogContentContext } from "./DialogContext";
import { DIVIDED_REGION_CLASS } from "./styles";

export type DialogHeaderProps = ComponentProps<"div">;

export const DialogHeader = ({ className, ...props }: DialogHeaderProps) => {
  const { divided } = useDialogContentContext();

  return (
    <div
      data-slot="dialog-header"
      className={cn("flex flex-col gap-2 text-center sm:text-left", divided && DIVIDED_REGION_CLASS, className)}
      {...props}
    />
  );
};
